const appOrigin = window.location.origin;

/** Post-logout landing page (Cordexa login, not CIAM hosted UI). Register in Entra redirect URIs. */
export const POST_LOGOUT_REDIRECT_URI = `${appOrigin}/login`;

export const MSAL_REDIRECT_URI = appOrigin;
